import { GiftRedeemPage } from './GiftRedeemPage'

export { GiftRedeemPage }

export default GiftRedeemPage
